import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { ParentalConsentContext } from '../index';
import Button from '../../../components/Button';
import Checkmark from '../../../static/img/feedback-success.svg';
import Icon from '../../../components/Section/Icon';
import { Actions, Categories, Labels } from '../../../types/gtm';
import { useAuth } from '../../../hooks/useAuth';

const DivDetails = styled.div`
  margin-top: 64px;
  align-items: center;
  justify-content: center;
  @media (max-width: 650px) {
    margin-top: 48px;
  }
`;

const DivCustom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  > img {
    width: 82px;
  }
  h1 {
    font-size: 20px;
    margin: 0;
    padding: 24px 0;
  }
  p {
    margin: 0;
  }
  margin-bottom: 32px;
`;

const DivFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  > button {
    padding: 0 8px;
  }
`;

const Success = () => {
  const history = useHistory();
  const { step, underageUser } = useContext(ParentalConsentContext);
  const { user } = useAuth();

  function getLabelsEventGA() {
    const ret = {
      labelEvent: Labels.BlockSuccessScreen,
    };
    if (step.type === 'unblock') {
      ret.labelEvent = Labels.UnblockSuccessScreen;
    }

    if (step.type === 'delete') {
      ret.labelEvent = Labels.ExclusionSuccessScreen;
    }

    return ret;
  }

  const { labelEvent } = getLabelsEventGA();

  function back() {
    window.dataLayer.push({
      event: 'customEventUserInteraction',
      event_category: Categories.ParentalConsent,
      event_action: Actions.ClickBackHome,
      event_label: labelEvent,
      bd_suser_code: user?.globoId,
    });
    history.push('/');
  }

  function getTexts() {
    const ret = {
      title: 'Bloqueio temporário definido com sucesso!',
      description: (
        <p>
          Enviamos um e-mail para <b>{underageUser.name}</b> informando o
          bloqueio. Se você mudou de ideia, acesse Minha Conta {'>'}{' '}
          Consentimento Parental para realizar o desbloqueio.
        </p>
      ),
    };

    if (step.type === 'unblock') {
      ret.title = 'Desbloqueio temporário definido com sucesso!';
      ret.description = (
        <p>
          Enviamos um e-mail para <b>{underageUser.name}</b> informando o
          desbloqueio. Se você mudou de ideia, acesse Minha Conta {'>'}{' '}
          Consentimento Parental para realizar o bloqueio.
        </p>
      );
    }

    if (step.type === 'delete') {
      ret.title = 'Pedido de exclusão realizado com sucesso!';
      ret.description = (
        <p>
          Você solicitou a exclusão da Conta Globo de{' '}
          <b>{underageUser.name}.</b> Este processo pode levar alguns dias.
          Depois disso, todos os dados serão apagados definitivamente.
        </p>
      );
    }

    return ret;
  }

  const { title, description } = getTexts();

  return (
    <DivDetails>
      <DivCustom>
        <Icon svg={Checkmark} alt="success" />

        <h1>{title}</h1>

        <p>{description}</p>
      </DivCustom>
      <DivFooter>
        <Button onClick={() => back()} variant="secondary">
          Voltar para página principal
        </Button>
      </DivFooter>
    </DivDetails>
  );
};

export default Success;
